<template>
  <SectionVideo
    id="SectionSmartSave"
    :content="$t('paragraph')"
    :cta="$t('cta')"
    :title="$t('title')"
    videoSrc="https://www.youtube.com/embed/8A-Yp2B55Ws" />
</template>

<script>
import SectionVideo from './SectionVideo'

export default {
  components: { SectionVideo },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "lt": {
    "title": "Sutaupykite daugiau su išmaniąja įranga",
    "paragraph": "Mūsų siūloma išmani optimizuota sistema užtikrina iki 25% efektyvesnį elektrinės darbą, lankstesnes modulių išdėstymo galimybes ir didesnį saugumą. Daugiau apie optimizuotą įrangą sužinokite pažiūrėję informacinį vaizdo klipą:",
    "cta": "Gaukite pasiūlymą"
  }
}
</i18n>
